import { useMemo, useState } from "react";
import { Tag, ChevronLeft, ChevronRight } from "lucide-react";

export default function OfferGallery({ offer }) {
  const list = useMemo(() => {
    const arr = Array.isArray(offer?.images) ? offer.images.filter(Boolean) : [];
    if (arr.length) return arr;
    if (offer?.image) return [offer.image];
    return [];
  }, [offer]);
  const [idx, setIdx] = useState(0);

  if (!list.length) {
    return (
      <div className="rounded-2xl overflow-hidden border border-slate-200 aspect-video bg-slate-100">
        <div className="w-full h-full grid place-items-center text-slate-300"><Tag size={60}/></div>
      </div>
    );
  }

  const prev = () => setIdx((i) => (i - 1 + list.length) % list.length);
  const next = () => setIdx((i) => (i + 1) % list.length);

  return (
    <div data-testid="offer-gallery">
      <div className="relative rounded-2xl overflow-hidden border border-slate-200 aspect-video bg-slate-100">
        <img
          src={list[idx]}
          alt={`${offer.title} ${idx + 1}/${list.length}`}
          className="w-full h-full object-cover"
          data-testid="offer-gallery-main"
        />
        {list.length > 1 && (
          <>
            <button
              type="button"
              onClick={prev}
              aria-label="Image précédente"
              data-testid="offer-gallery-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 grid place-items-center rounded-full bg-white/95 hover:bg-white shadow"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              type="button"
              onClick={next}
              aria-label="Image suivante"
              data-testid="offer-gallery-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 grid place-items-center rounded-full bg-white/95 hover:bg-white shadow"
            >
              <ChevronRight size={18} />
            </button>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full bg-black/60 text-white text-xs font-semibold">
              {idx + 1} / {list.length}
            </div>
          </>
        )}
      </div>
      {list.length > 1 && (
        <div className="mt-3 grid grid-cols-5 gap-2">
          {list.map((src, i) => (
            <button
              type="button"
              key={i}
              onClick={() => setIdx(i)}
              data-testid={`offer-gallery-thumb-${i}`}
              className={`aspect-square rounded-lg overflow-hidden border-2 transition ${
                i === idx ? "border-[#E05638]" : "border-transparent hover:border-slate-300"
              }`}
            >
              <img src={src} alt={`Miniature ${i + 1}`} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
